module.exports = __webpack_public_path__ + "static/fipcpinkfloralmain-e4934561ecce5905d61f877f51f317f6.jpeg";